import type { Login, Logout, AdminProxyLogin } from '@/types/api/admin/Auth'

import { useApiForPublic, useApiForAdmin } from '@/composables/useApi'

/**
 * ログインする
 */
export const login: Login = payload =>
  useApiForPublic('/rest/admin/auth/login', {
    method: 'POST',
    body: {
      payload,
    },
  })

/**
 * ログアウトする
 */
export const logout: Logout = () =>
  useApiForAdmin('/rest/admin/auth/logout', {
    method: 'POST',
  })

/**
 * 代理ログインする
 */
export const adminProxyLogin: AdminProxyLogin = (userId: string) =>
  useApiForPublic(`/rest/admin/auth/proxy-users/${userId}/login`, {
    method: 'POST',
  })
